import axios from 'axios';
import { API_URL } from '../config';
import { Justification } from '../types';

export const getJustificationsList = async (token: string) => {
    const response = await axios.get(`${API_URL}/presenze/justifications/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
      return response.data;
  };
  
  export const getJustificationsCompanyList = async (token: string, id?: string) => {
    const response = await axios.get(`${API_URL}/presenze/company/justifications/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };
  
  export const getJustificationCompany = async (token: string, id?: string) => {
    const response = await axios.get(`${API_URL}/presenze/company/justifications/${id}`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };
  
  export const deleteJustificationCompany = async (token: string, id: string | number) => {
    const response = await axios.delete(`${API_URL}/presenze/company/justifications/${id}`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };
  
  export const addJustificationCompany = async (token: string, justificationId: number) => {
    const response = await axios.post(`${API_URL}/presenze/company/justifications/`,
      {
        justification: justificationId,  
      },
      {
        headers: {
          'Authorization': `${token}` 
        }
      }
    );
    return response.data;
  }

  export const addJustificationCustomCompany = async (token: string, justification: Justification) => {

    if(justification.rateo === null) {
      delete justification.rateo
    }

    const response = await axios.post(`${API_URL}/presenze/company/justifications/custom/`,
      justification 
      ,
      {
        headers: {
          'Authorization': `${token}` 
        }
      }
    );
    return response.data;
  }

  export const getJustificationCustomCompanyList = async (token: string) => {
    const response = await axios.get(`${API_URL}/presenze/company/justifications/custom/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };


  export const getJustificationCustomCompany = async (token: string, id?: string) => {
    const response = await axios.get(`${API_URL}/presenze/company/justifications/custom/${id}`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };

  export const deleteJustificationCustomCompany = async (token: string, id: string) => {
    const response = await axios.delete(`${API_URL}/presenze/company/justifications/custom/${id}/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };

  export const updateJustificationCustomCompany = async (token: string, id: number, justificationData: any) => {
    const response = await axios.put(`${API_URL}/presenze/company/justifications/custom/${id}/`,
      justificationData,
      {
        headers: {
          'Authorization': token,
        },
      }
    );
  };
